import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Item} from "../../models/Item";
import {animate, style, transition, trigger} from "@angular/animations";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {ConcreteLayer} from "../../classes/concreteLayers/ConcreteLayer";
import {ConcreteHierarchyItemInterface} from "../../classes/concreteLayers/ConcreteHierarchyItemInterface";
import {filter, throttle} from 'rxjs/operators';
import {interval, Subject} from "rxjs";
import {ObjectConfig} from "../../models/ObjectConfig";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {GlobalEventsService} from "@src/app/services/global-events.service";
import {MapPosition} from "@src/app/models/MapPosition";
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';
import {HttpHeaders, HttpParams} from "@angular/common/http";
import {HttpServiceService} from "@src/app/services/httpService/http-service.service";
declare const Yiit;

@Component({
  selector: 'app-item-details-sidebar',
  templateUrl: './item-details-sidebar.component.html',
  styleUrls: ['./item-details-sidebar.component.scss'],
  animations: [
    trigger('animateShow', [
      transition(':enter', [
        style({opacity: 0, paddingBottom: '0', height: '0'}),
        animate('300ms ease-out',  style({opacity: 1, paddingBottom: '*', height: '*'}))
      ]),
      transition(':leave', [
        style({opacity: 1, paddingBottom: '*', height: '*'}),
        animate('300ms ease-in', style({opacity: 0, paddingBottom: '0', height: '0'}))
      ])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ItemDetailsSidebarComponent extends AbstractObserver implements OnInit {
  public selectedElm: ConcreteHierarchyItemInterface;
  private item: Item;
  private concrete: ConcreteLayer;
  public isItem = false;
  public isOverlay = false;
  public isTopCl = false;
  public hideDetailsSidebar = null;
  private availableFileTypes = ['png', 'jpg', 'jpeg', 'svg'];
  public _opacity:number;
  private opacityChanged$ = new Subject<number>();

  public Yiit = Yiit;
  private deleteSubscriber = null;
  public isViewModeOnly = isViewMode || isViewModeByShareLink;

  set opacity(value:number){
    let val = value;
    if (value < 0 ){
      val = 0;
    }
    if (value > 100 || value === null || isNaN(value)){
      //workaround for change detection
      this._opacity = val;
      this.cd.detectChanges();
      val = 100;
    }
    this._opacity = val;
    this.opacityChanged$.next(val);
    this.cd.detectChanges()
  }

  get opacity(){
    return this._opacity;
  }

  constructor(
    private ui: UiAdapterService,
    private cd: ChangeDetectorRef,
    private concreteService: ConcreteLayerService,
    private uiAdapterService: UiAdapterService,
    private notification: GlobalEventsService,
    protected http: HttpServiceService
  ) {
    super();
  }

  ngOnInit() {
    this.hideDetailsSidebar = this.ui.isDetailsSidebarHidden;

    this.subscribeToObservable(this.ui.onHideDetailsSidebarUpdated$, (val: boolean) => {
      this.hideDetailsSidebar = val;
      this.cd.detectChanges();
    });

    // this.ui.onHideDetailsSidebarUpdated$.subscribe();

    this.subscribeToObservable(this.ui.selectedItem$.pipe(
    //   filter( _item => {
    //   //check to prevent display information for the copy of objects of array
    //   //if you have another idea how to prevent it inside plugin pls rewrite it or contact me
    //   if (_item instanceof Item){
    //     return !_item.config.isCopy;
    //   }
    //   return true;
    // })
    ), ((selectedItem) => {
      this.isItem = selectedItem instanceof Item;

      this.selectedElm = selectedItem;
      this.isTopCl = selectedItem && selectedItem.hasOwnProperty('id') && selectedItem.id === null;
      console.log('selectedElm', this.selectedElm);
      if (this.selectedElm instanceof Item) {
        this.item = this.selectedElm;
        this.deleteSubscriber = this.item.emitter.subscribe((e) => {
          if (e.getEventName() === 'removeObject') {
            this.selectedElm = null;
            this.cd.detectChanges();
            this.deleteSubscriber.unsubscribe();
          }
        });
      } else if (this.selectedElm instanceof ConcreteLayer) {
        this.concrete = this.selectedElm;
        this.opacity = (this.concrete.objectConfig.getFillOpacity() === null) ? 100 : this.concrete.objectConfig.getFillOpacity()*100;
        this.isOverlay = this.concrete.isOverlay;
      }
      this.cd.detectChanges();
    }));

    this.subscribeToObservable(this.opacityChanged$.pipe(
      throttle(config => interval(1000), {trailing: true})
    ), ((value) => {
      this.concrete.objectConfig.setFillOpacity((value / 100).toFixed(2));

      console.log('opacityChanged$', value);

      if (this.isOverlay){
        console.log('isOverlay', this.isOverlay);
        this.concrete.overlay.setOpacity(parseFloat((value / 100).toFixed(2)));
      }
      // this.concreteService.updateConcreteOptions(this.concrete);
      this.cd.detectChanges();
    }))

  }

  get title() {
    return this.selectedElm.getTitle();
  }
  setTitle(event:{target: {value: string}}){
    let value = event.target.value;
    if (this.selectedElm instanceof Item) this.selectedElm.setTitle(value);
    this.cd.detectChanges();
  }

  getImg() {
    if (this.selectedElm instanceof Item) {
      let img = this.selectedElm.config.getObjectConfig().getMapIcon()
        || this.selectedElm.config.getObjectConfig().getMenuIcon();
      if (img) {
        return encodeURI(img);
      }
      return null;
    }
    return null;
  }

  copyObjectPosition($event, item){
    $event.preventDefault();
    // @ts-ignore
    if (navigator.clipboard){
      let position = this.item.config.getObjectConfig().getCenterPosition();
      if (position instanceof MapPosition){
        // @ts-ignore
        position = position.asSimpleObject();
      }
      let positionStr = ``;
      // @ts-ignore
      delete position.height;
      for (let i in position){
        positionStr+=`${position[i]}, `;
      }
      positionStr = positionStr.slice(0, -2);
      // @ts-ignore
      navigator.clipboard.writeText(positionStr).then(()=>{
        this.notification.ToastNotificationEvent.emit({
          message: 'Coordinates copied to clipboard',
          autoHideDelay: 1500,
          title: 'Coordinates copied',
          classes: ['notification']
        })
      });
    }
    else{
      this.notification.ToastNotificationEvent.emit({
        message: 'Position copy error',
        autoHideDelay: 1500,
        title: 'Your browser does not support copying',
        classes: ['error']
      })
    }
    const csrfFrontend = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content;
    this.http.sendPostRequest('/event/log-event-analytics/'+window['EVENT_ID'],
      new HttpParams()
        .set('_csrf-frontend', csrfFrontend.toString())
        .set('event_name', 'latlng_copy')
        .set('data', '{"object_id": "' + item.getId() + '"}')
        .toString(),
      new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded'
      })
    ).subscribe();
  }

  updateConcreteTitle(event) {
      this.concrete.setTitle(event.target.value);
      this.concreteService.saveConcreteLayer(this.concrete, () => {
        this.cd.detectChanges();
      })
  }

  centerOnConcrete(){
    this.concreteService.centerOnConcrete(this.selectedElm);
  }

  removeConcrete(){
    this.concreteService.removeConcreteLayer(this.concrete, (result)=>{
      if (result){
        this.selectedElm = null;
        this.cd.detectChanges();
      }
    });
    this.cd.detectChanges();
  }
  hasBgImage(){
    return <ConcreteLayer>this.selectedElm.bgImageUrl != null;
  }

  setNewImgToConcrete(event){
    if (!event){
      if (this.selectedElm instanceof ConcreteLayer){
        this.selectedElm.setBgImageUrl(null);
        this.concreteService.saveConcreteLayer(this.selectedElm, ()=>{
          this.concreteService.updateConcreteOptions(<ConcreteLayer>this.selectedElm);
          this.cd.detectChanges();
        });
      }
      return;
    }
    let file:File = event.target.files[0];
    if (!file.size){
      alert(Yiit.t('Wrong file'));
     return;
    }
    let type = file.type.substring(file.type.indexOf('/')+1, file.type.length);
    if (!this.availableFileTypes.includes(type.toLocaleLowerCase())){
      alert(Yiit.t('Wrong file type'));
      return;
    }

    this.concreteService.uploadConcreteLayerImage(<ConcreteLayer>this.selectedElm, file, (fileUrl)=>{
      this.cd.detectChanges();
    });
  }

  private updateImage(f, cb) {
    if (!f.type.match('image.*')) {
      cb(null);
      return;
    }

    var reader = new FileReader();

    // Closure to capture the file information.
    reader.onload = (function(theFile) {
      return function(e) {
        var data = e.target.result;
        cb(data);
      };
    })(f);

    reader.readAsDataURL(f);
  }

  public addConcreteLayer() {
    this.concreteService.drawConcreteLayer(null, (concrete: ConcreteLayer, error?) => {
      if (!error) {
        concrete.onSelect();
        this.uiAdapterService.selectedItem$ = concrete;
        this.cd.detectChanges();
      } else {
        alert(error);
      }
    });
  }

  isFixedFigure(){
    return this.item.config.getObjectConfig().getToolType() == ObjectConfig.TYPE_FIXED_FIGURE;
  }

  isCategoriesAllowed(){
    return true;
    return window['CANVAS_STORE_ALLOWED'];
  }

  closeSidebar(){
    this.ui.hiddenDetailsSidebar = true;
    this.selectedElm = null;
  }

}
